module.exports = __webpack_public_path__ + "static/media/ilustracion-komunidad-textura.e585e586.png";